import { render, staticRenderFns } from "./PositionTemplateEditor.vue?vue&type=template&id=146f4444&scoped=true&"
import script from "./PositionTemplateEditor.vue?vue&type=script&lang=js&"
export * from "./PositionTemplateEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146f4444",
  null
  
)

export default component.exports